import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  GET_VERIFIED_MERCHANT,
  ELASTIC_SEARCH_BASE_URL,
  GET_MERCHANTS,
  GET_VERIFIED_MERCHANT_COUNT,
  GET_MERCHANT_DATA,
} from "../../../Constants/Config";
import { ciBase, ciUrl } from "../../../Constants/nodeCi";
import axios from "axios";

let initialState = {
  loading: false,
  verifiedMerchantData: {},
  verifiedMerchantCount: 0,
  MerchantCount: 0,
  error: "",
};

let IS_ELASTIC_CONNECTED = false;
export const getVerifiedMerchantCount = createAsyncThunk(
  "Verified/getVerifiedMerchantCount",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      console.log("dataNew", dataNew, data, token);
      const response = await axios.post(
        ciUrl(GET_VERIFIED_MERCHANT_COUNT),
        // BASE_URL + GET_MERCHANT_DATA,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Use data?.token directly
          },
        }
      );
      if (response.data.status == 200) {
        return response.data.total_count;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
export const getMerchantCount = createAsyncThunk(
  "Verified/getMerchantCount",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        // BASE_URL + GET_VERIFIED_MERCHANT_COUNT,
        BASE_URL + GET_MERCHANT_DATA,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Use data?.token directly
          },
        }
      );
      if (response.data.status == 200) {
        return response.data.total_count;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const getVerifiedMerchant = createAsyncThunk(
  "Verified/getVerifiedMerchant",
  async (data, { getState, rejectWithValue }) => {
    const state = getState();
    const isElasticConnected = state.permissions.isElasticConnected;
    IS_ELASTIC_CONNECTED = isElasticConnected;
    // let baseurl = isElasticConnected ? ELASTIC_SEARCH_BASE_URL : BASE_URL;
    let baseurl = ciBase(GET_VERIFIED_MERCHANT);
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(
        baseurl + GET_VERIFIED_MERCHANT,
        // BASE_URL + GET_MERCHANT_DATA,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //    console.log(response)
      if (response.data.status == 200) {
        // if (baseurl == ELASTIC_SEARCH_BASE_URL && IS_ELASTIC_CONNECTED) {
        if (baseurl) {
          return {
            response: response.data.message,
            total: response.data.total,
          };
        } else {
          return response.data.message;
        }
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
export const getMerchants = createAsyncThunk(
  "Verified/getVerifiedMerchant",
  async (data, { getState, rejectWithValue }) => {
    const state = getState();
    const isElasticConnected = state.permissions.isElasticConnected;
    IS_ELASTIC_CONNECTED = isElasticConnected;
    let baseurl = isElasticConnected ? ELASTIC_SEARCH_BASE_URL : BASE_URL;
    try {
      const { token, ...dataNew } = data;
      let endPoint = isElasticConnected
        ? GET_VERIFIED_MERCHANT
        : GET_MERCHANT_DATA;
      const response = await axios.post(baseurl + endPoint, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status === 200) {
        if (baseurl == ELASTIC_SEARCH_BASE_URL && IS_ELASTIC_CONNECTED) {
          return {
            response: response.data.message,
            total: response.data.total,
          };
        } else {
          return response.data.message;
        }
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
export const VerifiedMerchantSlice = createSlice({
  name: "Verified",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getVerifiedMerchant.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getVerifiedMerchant.fulfilled, (state, action) => {
      state.loading = false;
      if (
        action.payload?.status === 400 &&
        action.payload?.message === "no record found"
      ) {
        state.verifiedMerchantData = [];
        state.MerchantCount = 0;
      } else if (
        ELASTIC_SEARCH_BASE_URL &&
        ELASTIC_SEARCH_BASE_URL.length &&
        IS_ELASTIC_CONNECTED
      ) {
        state.verifiedMerchantData = action.payload?.response || [];
        state.MerchantCount = action.payload?.total || 0;
      } else {
        state.verifiedMerchantData =
          action.payload?.response || action.payload || [];
      }
      state.error = "";
    });
    builder.addCase(getVerifiedMerchant.rejected, (state, action) => {
      state.loading = false;
      state.verifiedMerchantData = [];
      state.error = action.error.message;
    });
    builder.addCase(getVerifiedMerchantCount.fulfilled, (state, action) => {
      state.verifiedMerchantCount = action.payload;
    });
    builder.addCase(getVerifiedMerchantCount.rejected, (state, action) => {
      state.verifiedMerchantCount = 0;
    });
    builder.addCase(getMerchantCount.fulfilled, (state, action) => {
      if (!IS_ELASTIC_CONNECTED) {
        state.MerchantCount = action.payload;
      }
    });
    builder.addCase(getMerchantCount.rejected, (state, action) => {
      state.MerchantCount = 0;
    });
  },
});
export default VerifiedMerchantSlice.reducer;
